<template>
  <BaseAction>
    <PrimaryButton
      light
      @click.native="openDialog"
      :class="{ 'full-width': isMobile }"
    >
      Create New
    </PrimaryButton>
    <AddInterviewFormatDialog
      @close="closeDialog"
      :isOpen="isOpen"
      v-if="isOpen"
    />
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import AddInterviewFormatDialog from "@/views/bookings/BookingInterviews/components/dialogs/AddInterviewFormatDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "AddInterviewFormatAction",
  components: {
    AddInterviewFormatDialog,
    PrimaryButton,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
